import { render, staticRenderFns } from "./ModelloMessaggio.vue?vue&type=template&id=496a8f6b&scoped=true&"
import script from "./ModelloMessaggio.vue?vue&type=script&lang=js&"
export * from "./ModelloMessaggio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a8f6b",
  null
  
)

export default component.exports